import React, { useEffect, useState } from "react";
import { Trash2, MessageSquareText } from "lucide-react";
import { adminApi } from "../../lib/adminAuth";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const load = () => adminApi.listReviews().then(setReviews).catch(() => {});
  useEffect(load, []);

  const remove = async (r) => {
    if (!window.confirm(`¿Eliminar reseña de ${r.user_handle}?`)) return;
    await adminApi.deleteReview(r.id);
    load();
  };

  return (
    <div data-testid="admin-reviews-page" className="space-y-6">
      <header>
        <div className="font-mono text-[10px] uppercase tracking-widest text-[#FEBA01]">Moderación</div>
        <h1 className="font-display text-4xl uppercase tracking-tight">Reseñas</h1>
        <p className="text-sm text-[#A3A3A3] mt-1">{reviews.length} reseñas en total. Elimina spam o contenido inapropiado.</p>
      </header>

      {reviews.length === 0 ? (
        <div className="border-2 border-dashed border-[#333] p-10 text-center">
          <MessageSquareText size={32} className="mx-auto text-[#FEBA01] mb-3" />
          <div className="font-display text-xl uppercase">Sin reseñas todavía</div>
        </div>
      ) : (
        <div className="space-y-3">
          {reviews.map((r) => (
            <div key={r.id} className="bg-[#1A1A1A] border-2 border-[#333] p-4" data-testid={`admin-review-${r.id}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="font-display uppercase">{r.user_handle}</div>
                    <div className="text-[#FEBA01] text-sm">{"★".repeat(r.rating)}<span className="text-[#333]">{"★".repeat(5 - r.rating)}</span></div>
                    <div className="font-mono text-[10px] uppercase tracking-widest text-[#666]">en {r.venue_name}</div>
                  </div>
                  <p className="mt-2 text-sm text-[#F5F5F5] whitespace-pre-line">{r.text}</p>
                  {r.tags?.length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-1.5">
                      {r.tags.map((t) => <span key={t} className="px-2 py-0.5 bg-[#0A0A0A] border border-[#333] text-[#FEBA01] font-mono text-[10px] uppercase">{t}</span>)}
                    </div>
                  )}
                  {r.photo_base64 && <img src={r.photo_base64} alt="" className="mt-2 max-h-40 object-cover border border-[#333]" />}
                  <div className="mt-2 font-mono text-[10px] uppercase tracking-widest text-[#666]">
                    {new Date(r.created_at).toLocaleString("es-CL")} · {r.helpful_count} útiles
                  </div>
                </div>
                <button onClick={() => remove(r)} className="border-2 border-red-500 text-red-400 hover:bg-red-500 hover:text-white p-2 shrink-0" aria-label="Eliminar" data-testid={`admin-review-delete-${r.id}`}>
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
